import styled from 'styled-components';

export const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: ${({ theme }) => theme.colors.white};
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  margin: 50px auto;
`;

export const StyledInput = styled.input`
  padding: 10px;
  border: 1px solid ${({ theme }) => theme.colors.greyNickel};
  border-radius: 5px;
  font-size: 14px;
  outline: none;

  &:focus {
    border-color: ${({ theme }) => theme.colors.pink};
    box-shadow: 0 0 5px rgba(255, 105, 180, 0.5);
  }
`;

export const SubmitButton = styled.button`
  background: ${({ theme }) => theme.colors.pink};
  color: white;
  padding: 10px;
  font-size: 14px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background 0.3s ease-in-out;

  &:hover {
    background: ${({ theme }) => theme.colors.darkPink};
  }
`;

export const ErrorMessage = styled.p`
  color: red;
  font-size: 12px;
  text-align: center;
  margin: 5px 0;
`;

export const StyledImage = styled.img`
width: 360px;
`;

export const StyledComment = styled.p`
margin: 0;
font-size: 14px;
`;

export const ForgotPasswordLink = styled.p`
  font-size: 12px;
  text-align: center;
  cursor: pointer;
  margin: 0;

  &:hover {
    font-weight: 500;
    text-decoration: underline;
  }
`;

export const InputWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;  
  position: relative; 
`;

export const EyeStyled = styled.span`
  position: absolute;
  right: 10px;  
  top: 50%;  
  transform: translateY(-50%);  
  cursor: pointer;
  color: #666;  
  font-size: 20px; 
`;
export const SuccessMessageWrapper = styled.div`
  background: ${({ theme }) => theme.colors.white};
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  max-width: 700px;
  margin: 10px auto;
  text-align: center;
  padding: 30px;
`;

export const SuccessMessage = styled.p`
  font-size: 15px;
  margin-bottom: 20px;
`;

